// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"850":"3f9a5a0a","1634":"2c27652f","1704":"ab9fc633"}[chunkId] + ".css";
};